import React from 'react'

function PageTitle({children, className}) {
    return (
        <h1 className={`${className} my-6 text-2xl font-semibold text-gray-700 dark:text-gray-200`}>{children}</h1>
    )
}

export default PageTitle
